import { defineAsyncComponent } from 'vue';

import LDRouteGuard from '@/components/core/LDRouteGuard';

const App = () => import('@/app/shared/App.vue');
const SharedLinkUnavailable = () => import('@/app/shared/pages/SharedLinkUnavilable.vue');
const SharedCalendar = defineAsyncComponent(
  () => import('@/app/scheduler/pages/SharedCalendar.vue'),
);

const PAGE_LEVEL_TOP = `Shared Link`;

export default {
  path: '',
  component: App,
  meta: {
    hideNav: true,
    hidePrimaryNav: true,
    hideSecondaryNav: true,
    hideVisionAi: true,
  },
  children: [
    {
      name: 'shared.link-unavailable',
      path: 'shared-link-unavailable',
      component: SharedLinkUnavailable,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Unavailable`,
      },
    },
    {
      name: 'shared.scheduler-calendar',
      path: 'scheduler/shared/:sharedLinkId',
      component: LDRouteGuard,
      props: {
        component: SharedCalendar,
        requiredFeatureFlag: 'shareableCalendarLinks',
        to: { name: 'shared.link-unavailable' },
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Scheduler Calendar`,
        shared: true,
      },
    },
  ],
};
